module.exports = __webpack_public_path__ + "img/bell-ringing.172c442c.svg";